import { ActionReducerMapBuilder, createAsyncThunk } from "@reduxjs/toolkit";
import { dashboardAPI } from "../../../../Api/dashboardAPI";
import { DashboardInitState } from "../../Slices/dashboardSlice";


export const postActualizarCupos = createAsyncThunk(
  "dashboard/actualizarCupos",
  async (_, thunkAPI) => {
    try {
      console.log("Actualizando estado de tablas mirror...");
      const response = await dashboardAPI.actualizarCupos();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getActualizarTablasMirror = createAsyncThunk(
  "dashboard/estadoTablasMirror",
  async (_, thunkAPI) => {
    try {
      console.log("Actualizando estado de tablas mirror...");
      const response = await dashboardAPI.actualizarSincronizacionTablasMirror();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getEstadoTablasMirror = createAsyncThunk(
  "dashboard/estadoTablasMirror",
  async (_, thunkAPI) => {
    try {
      console.log("Actualizando estado de tablas mirror...");
      const response = await dashboardAPI.estadoTablasMirror();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const checkSyncTablasMirror = createAsyncThunk(
  "dashboard/checkSyncTablasMirror",
  async (_, thunkAPI) => {
    try {
      console.log("Actualizando estado de tablas mirror...");
      const response = await dashboardAPI.checkSyncTablasMirror();
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateSincronizacionTabla = createAsyncThunk(
  "dashboard/actualizarSincronizacionTabla",
  async (clave: string, thunkAPI) => {
    try {
      console.log("Actualizando estado de tabla mirror...");
      const response = await dashboardAPI.actualizarSincronizacionTabla(clave);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const checkSyncCountTablaMirror = createAsyncThunk(
  "dashboard/checkSyncCountTablaMirror",
  async (clave: string, thunkAPI) => {
    try {
      console.log("Actualizando estado de tabla mirror...");
      const response = await dashboardAPI.checkSyncCountTablaMirror(clave);
      return response;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getEstadoTablasMirrorBuilder = (
  builder: ActionReducerMapBuilder<DashboardInitState>
) => {
  builder.addCase(getEstadoTablasMirror.pending, (state, action) => {
    state.loadingPageScreen = true;
  });
  builder.addCase(getEstadoTablasMirror.fulfilled, (state, action) => {
    console.log("getEstadoTablasMirror fulfilled :>> ", action);
    state.loadingPageScreen = false;
    state.estadoTablasMirror = action.payload;
  });
  builder.addCase(getEstadoTablasMirror.rejected, (state, action) => {
    console.log("getEstadoTablasMirror rejected :>> ", action);
    state.loadingPageScreen = false;
  });
};
